import React from 'react';
import { translate } from 'react-i18next';
import SearchInput from '../SearchInput/SearchInput';
import styles from './MenuHeader.scss';
import {  SPECIAL_KEY_SYMBOL } from '../../utils/enviormentUtils';

function MenuHeader({
  query,
  filters,
  onClearFilters,
  onChange,
  onFilter,
  isFloating,
  organizationId,
  showFilters,
  toggleFilters,
  searchRef,
  t,
}) {
  const searchTooltipContent = `${t('phoneordering_keyboardShortcut_search_menus_tooltip')} (${SPECIAL_KEY_SYMBOL} + F)`;
  const filterTooltipContent = `${t('phoneordering_keyboardShortcut_filter_labels_tooltip')} (${SPECIAL_KEY_SYMBOL} + L)`;

  return (
    <div className={`${styles.wrapper} ${isFloating ? styles.float : ''}`}>
      <SearchInput
        filterTooltipContent={filterTooltipContent}
        searchTooltipContent={searchTooltipContent}
        searchRef={searchRef}
        toggleFilters={toggleFilters}
        showFilters={showFilters}
        className={styles.input}
        query={query}
        filters={filters}
        onChange={onChange}
        onFilter={onFilter}
        onClearFilters={onClearFilters}
        organizationId={organizationId}
      />
    </div>
  );
}

export default translate()(MenuHeader);
